module.exports = __webpack_public_path__ + "static/03-96e07b9c0e71bc127c8a66817367c59c.jpg";